import {
	fieldMode,
	fieldType,
	fieldsGroupType,
	createFormProps,
	validationTypes,
} from 'components/FormCreatorComponent/types';

export interface formConfig {
	[key: string]: createFormProps[];
}

export const paymentPurposeForm = {
	name: 'page.managePendingRequests.forms.account',
	handleChange: () => {},
	fieldsGroups: [
		{
			type: fieldsGroupType.col,
			fields: [
				{
					type: fieldType.select,
					mode: fieldMode.readonly,
					props: {
						name: 'bank_account_country_id',
						label: 'page.payments_purpose_management.field.bank_account_country_id',
						required: true,
						disabled: false,
						options: [],
					},
					validation: [{ requierd: true }],
				},
				{
					type: fieldType.select,
					mode: fieldMode.readonly,
					props: {
						name: 'currencies_code',
						label: 'page.payments_purpose_management.field.currencies_code',
						required: true,
						disabled: false,
						options: [],
					},
					validation: [{ requierd: true }],
				},
				{
					type: fieldType.text,
					mode: fieldMode.readonly,
					props: {
						name: 'code',
						label: 'page.payments_purpose_management.field.code',
						required: true,
						disabled: false,
					},
					validation: [{ requierd: true }],
				},
			],
		},
		{
			type: fieldsGroupType.row,
			fields: [
				{
					type: fieldType.radio,
					mode: fieldMode.write,
					props: {
						name: 'payment_type',
						label: 'page.payments_purpose_management.field.payment_type',
						options: [
							{ value: 'Priority', label: 'label.priority', disabled: false },
							{ value: 'Regular', label: 'label.regular', disabled: false },
						],
						required: true,
						disabled: false,
					},
					//validation: [{ requierd: true }],
				},
			],
		},
		{
			type: fieldsGroupType.col,
			fields: [
				{
					type: fieldType.text,
					mode: fieldMode.readonly,
					props: {
						name: 'description',
						label: 'page.payments_purpose_management.field.description',
						required: true,
						disabled: false,
					},
					validation: [{ requierd: true }],
				},
				{
					type: fieldType.text,
					mode: fieldMode.readonly,
					props: {
						name: 'description_he',
						label: 'page.payments_purpose_management.field.description_he',
						required: true,
						disabled: false,
					},
					validation: [{ requierd: true }],
				},
			],
		},
		{
			type: fieldsGroupType.row,
			fields: [
				{
					type: fieldType.radio,
					mode: fieldMode.write,
					props: {
						name: 'active',
						label: 'label.active',
						options: [
							{ value: '1', label: 'label.yes', disabled: false },
							{ value: '0', label: 'label.no', disabled: false },
						],
						required: true,
						disabled: false,
					},
					//validation: [{ requierd: true }],
				},
			],
		},
	],
};
